import {
  SubscriptionNotActiveError,
  SubscriptionNotFoundError,
  SubscriptionNotValidError
  // @ts-ignore
} from "@seneca/course-service-client";

import { ErrorHandler, throttledLogError } from "seneca-common/utils/apiStates";

import courseServiceErrorTranslator from "./errorTranslator";

const courseServiceErrorHandler: ErrorHandler = (error, { errorAction }) => {
  errorAction(courseServiceErrorTranslator(error));

  if (
    !(
      error instanceof SubscriptionNotFoundError ||
      error instanceof SubscriptionNotActiveError ||
      error instanceof SubscriptionNotValidError
    )
  ) {
    throttledLogError(error);
  }
};

export default courseServiceErrorHandler;
